import React from "react";
import { Slide } from "react-reveal";
import s1 from "../../assets/images/nexus/1.png";
import s20 from "../../assets/images/nexus/20.png";
import s17 from "../../assets/images/nexus/17.png";
import s5 from "../../assets/images/nexus/5.png";
import s7 from "../../assets/images/nexus/7.png";
import s47 from "../../assets/images/nexus/47.png";
import s8 from "../../assets/images/nexus/8.png";
import s16 from "../../assets/images/nexus/16.png";
import Servicecard from "./ServiceCard";

const Services = () => {
  return (
    <div>
      <div className="service-cards-container flex">
        <Slide left>
          <Servicecard
            servTitle="Fashion Show Production"
            servImage={s5}
            servLink="https://form.jotform.com/nexusevents256/book-nexus-events-for-your-event"
          />
        </Slide>
        <Slide top>
          <Servicecard
            servTitle="Product Launches"
            servImage={s17}
            servLink="https://form.jotform.com/nexusevents256/book-nexus-events-for-your-event"
          />
        </Slide>
        <Slide top>
          <Servicecard
            servTitle="Concert Production"
            servImage={s47}
            servLink="https://form.jotform.com/nexusevents256/book-nexus-events-for-your-event"
          />
        </Slide>
        <Slide right>
          <Servicecard
            servTitle="Dinners &amp; Staff Parties"
            servImage={s7}
            servLink="https://form.jotform.com/nexusevents256/book-nexus-events-for-your-event"
          />
        </Slide>
        <Slide left>
          <Servicecard
            servTitle="End-End Party Planning"
            servImage={s1}
            servLink="https://form.jotform.com/nexusevents256/book-nexus-events-for-your-event"
          />
        </Slide>
        <Slide top>
          <Servicecard
            servTitle="Wedding Planning &amp; Production"
            servImage={s20}
            servLink="https://form.jotform.com/nexusevents256/book-nexus-events-for-your-event"
          />
        </Slide>
        <Slide top>
          <Servicecard
            servTitle="Crusades Production"
            servImage={s16}
            servLink="https://form.jotform.com/nexusevents256/book-nexus-events-for-your-event"
          />
        </Slide>
        <Slide right>
          <Servicecard
            servTitle="Awards &amp; Auditions"
            servImage={s8}
            servLink="https://form.jotform.com/nexusevents256/book-nexus-events-for-your-event"
          />
        </Slide>
      </div>
    </div>
  );
};

export default Services;
